import styled from 'styled-components'

const SwitchContainer = styled.div`
  display: flex;
  justify-content: center;
`

export default SwitchContainer
